import { colors as themeColors } from '../utils/theme';
import React from "react";
import { FormControl, Select, MenuItem, InputLabel, OutlinedInput } from "@mui/material";

const Dropdown = ({ id, name, label, value, options, onChange, valueKey, labelKey, disabled, required, error, helperText }) => {
  const selectedValue = value !== undefined && value !== null ? String(value) : "";

  return (
    <FormControl fullWidth size="small" disabled={disabled} variant="outlined" required={required} error={error} >
      <InputLabel
        id={`${id}-label`}
        required={required}
        sx={{
          '& .MuiFormLabel-asterisk': {
            color: 'red',   // 🔴 red star
          },
        }}
      >
        {label}
      </InputLabel>
      <Select labelId={`${id}-label`} id={id} name={name} value={selectedValue} input={<OutlinedInput notched label={label} />} displayEmpty
        onChange={(e) => {
          const newValue = e.target.value;
          if (newValue === "") {
            onChange({ [valueKey]: "", [labelKey]: "" });
          } else {
            const selectedOption = options.find((option) => String(option[valueKey]) === newValue);
            onChange(selectedOption);
          }
        }}
        renderValue={(selected) => {
          if (!selected) {
            return <span style={{ color: themeColors.neutral.muted }}>{label}</span>;
          }
          const option = options.find((option) => String(option[valueKey]) === selected);
          return option ? option[labelKey] : "";
        }}
      >
        <MenuItem value="">
          <em>Select</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option[valueKey]} value={String(option[valueKey])}>
            {option[labelKey]}
          </MenuItem>
        ))}
      </Select>
      {helperText && <p style={{ color: themeColors.error.dark, margin: '4px 14px 0', fontSize: '0.75rem' }}>{helperText}</p>}
    </FormControl>
  );
};

export default Dropdown;